import Component from '../abstracts/Component';
import 'bootstrap'; //TODO: import single component


export default class TooltipComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-toggle="tooltip"]',
      tooltip: '.tooltip'
    };
  }

  get OPTIONS() {
    return {
      trigger: "click",
      html: true
    }
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();
  }

  importTooltip() {


    let elements = document.querySelectorAll(this.SELECTORS.main);

    elements.forEach(el => {
      $(el).tooltip(this.OPTIONS);
    });

  }

  bindEvents() {
    // global
    let ctx = this;
    // check if there are tooltips in the modal
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, (e) => {
      let toggles = document.querySelectorAll('.vex '+ctx.SELECTORS.main);
      if (toggles !== null && toggles.length > 0) {
        toggles.forEach(el => {
          $(el).tooltip(this.OPTIONS);
        });
      }
    });
    // hide on closing
    this.$on(this.$customEvents.MODAL_EVENTS.afterClose, (e) => {
      let toggles = document.querySelectorAll(ctx.SELECTORS.tooltip);
      if (toggles !== null && toggles.length > 0) {
        toggles.forEach(el => {
          el.style.display = 'none';
        });
      }
    });

  }

  render() {
    if (document.querySelectorAll(this.SELECTORS.main)) this.importTooltip();
    this.bindEvents();
  }
}
